import React from "react";
import Navbar from "../Components/Navbar";
import Home from "../Components/Home";
import Footer from "../Components/Footer";
import ScrollBtn from "../Components/ScrollBtn";
import ContactBox from "../Components/ContactBox";
import About from "../Components/About";
import Contact from "../Components/Contact";
import Work from "../Components/Work";
import Panel from "../Components/Panel";
import Cursor from "../Components/Cursor";

const MainRoutes = () => {
  return (
    <>
      <Panel />
      <Cursor />
      <div className="main-container" id="main-container" data-scroll-container>
        <Navbar />
        <ScrollBtn />
        <ContactBox />
        <Home />
        <About />
        <Work />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default MainRoutes;
